<section class="content-header">

    <div class="container-fluid">
        <div class="row mb-2">
            <div class="col-sm-6">
                <h1 class="m-0 text-dark">Sample Testing Details</h1>
            </div>

        </div>
        <!-- /.row -->
    </div>
    <!-- /.container-fluid -->
</section>
<section class="content">
    <!-- Default box -->
    <div class="container-fluid">

        <div class="card">

            <div class="card-body">
                <!-- <div class="box-header with-border"> -->
                <div class="row">
                    <!-- <div class="col" style="font-weight: bold;">Vehicle No: {{vehicle}}</div> -->
                    <div class="col" style="font-weight: bold;">Sample Id: {{sampleId}}</div>
                    <!-- <div class="col" style="font-weight: bold;">Product: {{product}}</div> -->

                </div>
                <!-- </div> -->
                <div class="table-responsive no-padding">
                    <table class="table table-striped table-hover table-bordered">
                        <thead>
                            <tr>
                                <!-- <td>Sample#</td> -->
                                <td style="font-weight:bold">Parameter</td>
                                <td style="font-weight:bold">Value</td>
                                <td style="font-weight:bold">Result</td>

                                <!-- <td>Source</td> -->
                                <!-- <td colspan="2">Actions</td> -->
                            </tr>
                        </thead>

                        <tbody>
                            <tr *ngFor="let testing of testings">
                                <!-- <td>{{ testing.sampleId }}</td> -->
                                <td>{{ testing.parameterName }}</td>
                                <td>{{ testing.value }}</td>
                                <td>{{ testing.result }}</td>

                            </tr>
                        </tbody>
                    </table>
                </div>
                <!-- <a [routerLink]="['/list-testing-statewise']">Back</a> -->
                <button class="btn sm btn-primary" onclick="history.back()">Back</button>
            </div>
        </div>
    </div>
</section>